export enum EMediaType {
  AUDIO = `audio`,
  FILE = `file`,
  IMAGE = `image`,
  VIDEO = `video`,
}
